import createReducer from "Common/reducerUtils/createReducer";
import actionTypes from "./actionTypes";
export const initialState = { versionInfo: undefined };
export default createReducer(initialState, {
    [actionTypes.GET_VERSION_INFO_COMPLETED]: (state, { payload }) => ({
        ...state,
        versionInfo: payload
    })
});
